// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
enum PaymentType {
  PayGate = "PAY_GATE",
  Transfer = "TRANSFER",
}
export default PaymentType;
